import { useEffect } from 'react';
import warning from 'tiny-warning';

export function useRequiredPropWarning(
  condition: boolean,
  componentName: string,
  propName: string
) {
  useEffect(() => {
    warning(
      condition,
      `Свойство ${propName} обязательно для компонента ${componentName}.`
    );
  }, [condition]);
}
